import ConfirmationModal from 'modules/Modals/Confirmation/ConfirmationModal'

export default ConfirmationModal
